<div class="form">
  <form [formGroup]="sampleEditForm">
    <p class="heading" i18n>Edit</p>
    <div class="form__fields__container">
      <app-input
        [formCntlName]="sampleEditForm.get('Name')"
        [inputType]="'text'"
        [label]="'Panel Name'"
        [placeholder]="'Panel Name'"
      ></app-input>
      <div *ngIf="sampleEditForm.get('Name')?.hasError('required')" style="color: red">Panel Name is required.</div>
      <div *ngIf="sampleEditForm.get('Name')?.hasError('maxlength')" style="color: red">
        Panel Name cannot be longer than 256 characters
      </div>
      <div *ngIf="sampleEditForm.get('Name')?.hasError('whitespace')" style="color: red">
        Input cannot be just spaces.
      </div>
      <div class="edit-textarea">
        <label class="input-label" i18n>Panel Description</label>
        <textarea formControlName="Description" placeholder="Panel Description" rows="3" i18n></textarea>
        <div *ngIf="sampleEditForm.get('Description')?.hasError('maxlength')" style="color: red">
          Description cannot be longer than 1024 characters
        </div>
        <div *ngIf="sampleEditForm.get('Description')?.hasError('whitespace')" style="color: red">
          Input cannot be just spaces.
        </div>
      </div>
      <div class="group-select-container" style="margin-bottom: 1rem">
        <app-searchable-multi-select
          [label]="'Project/Group(s)'"
          [placeholder]="groupOptions.length > 0 ? 'Select Groups' : 'No groups to remove'"
          [options]="groupOptions"
          [formControlName]="'groups'"
          [multiple]="true"
          [disabledOptions]="disabledGroupOptions"
        ></app-searchable-multi-select>
      </div>
    </div>
    <div class="form__btn__container">
      <app-buttons
        [isDisabled]="false"
        [name]="buttonCancel"
        [arialLabel]="arialLabel"
        [buttonType]="btnMat"
        [buttonStyle]="btnStyleText"
        (buttonClickEvent)="closePopup()"
      ></app-buttons>
      <app-buttons
        [isDisabled]="
          !sampleEditForm.valid || (!sampleEditForm.dirty && sampleEditForm.get('groups')?.pristine) || isSubmitting
        "
        [name]="buttonSave"
        [buttonType]="btnMatFlat"
        [buttonStyle]="
          !sampleEditForm.valid || (!sampleEditForm.dirty && sampleEditForm.get('groups')?.pristine) || isSubmitting
            ? btnStyleFilledSmallDisabled
            : btnStyleFilledSmall
        "
        (buttonClickEvent)="onEditSubmit()"
      ></app-buttons>
    </div>
  </form>
</div>
